import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';

type UserSlice = RootState['userSlice'];

const selectUserSlice = (state: RootState) => state?.userSlice;

export const selectUser = createSelector(selectUserSlice, (state: UserSlice) => state?.user || null);

export const selectUserInboxes = createSelector(selectUserSlice, (state: UserSlice) => state?.inboxes);

export const selectUserPermissions = createSelector(selectUser, (state) => state?.permissions || []);

export const selectUserRoles = createSelector(selectUser, (state) => state?.roles || []);
